module.exports = __webpack_public_path__ + "static/media/5_The Cracked pot_SE.a26c9dd1.txt";